import React, { useContext, useState } from "react";
import { doLogin, doSendOtp } from "@AUTH";
import { Form, Input, Button, Space, Radio } from "antd";
import { AuthContext } from "@CONTEXTS";
import "./index.scss";
import { useHistory } from "react-router";
import { jetPartner, hepsiTruck, cargoPlane } from "../../../assets/icons";
import OtpPage from "../otp";
import VerifyAuthType from "../verify-auth-type";

const LoginPage = () => {
  const [loginForm] = Form.useForm();
  const { setToken } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [loadedImages, setLoadedImages] = useState([]);
  const history = useHistory();
  const [verification, setVerification] = useState(null);
  const [verificationTypes, setVerificationTypes] = useState(null);
  const [notVerifiedEmail, setNotVerifiedEmail] = useState(null);

  const handleLogin = async (val) => {
    setLoading(true);
    const token = await doLogin(val);
    setLoading(false);
    if (token === "blockedPassword") {
      history.push("/auth/unlock-password");
      return;
    }
    if (token === "blockedAccount") {
      history.push("/auth/unlock-password?type=lockedAccount");
      return;
    }
    sessionStorage.removeItem("channel");
    if (token?.notVerified) {
      setNotVerifiedEmail(val?.email);
      return;
    }
    if (token?.verificationTypes) {
      if (token?.verificationTypes.length === 1) {
        onFinish({ verificationType: token?.verificationTypes[0] });
      } else {
        setVerificationTypes(token?.verificationTypes);
      }
      return;
    }
    if (token) {
      setToken(token);
    }
  };
  const onFinish = async (val) => {
    setLoading(true);
    const { verificationType } = val;
    const verification = await doSendOtp({
      verificationType,
    });
    if (verification) {
      setVerificationTypes(null);
      setVerification(verification);
    }
    setLoading(false);
  };
  return (
    <>
      <div className="app-login">
        {notVerifiedEmail && <VerifyAuthType email={notVerifiedEmail} />}
        <div className="app-login-logo-container">
          <div className="app-login-logo-logos">
            <img
              src={jetPartner}
              alt=""
              className="jetPartner-logo"
              style={{ visibility: loadedImages.length > 2 ? true : false }}
              onLoad={() => {
                let tempLoaded = [...loadedImages];
                tempLoaded.push("jetPartner");
                setLoadedImages(tempLoaded);
              }}
            />
            <img
              src={cargoPlane}
              alt=""
              className="cargoPlane-logo"
              style={{ visibility: loadedImages.length > 2 ? true : false }}
              onLoad={() => {
                let tempLoaded = [...loadedImages];
                tempLoaded.push("cargo");
                setLoadedImages(tempLoaded);
              }}
            />
            <img
              src={hepsiTruck}
              alt=""
              className="hepsiTruck-logo"
              style={{ visibility: loadedImages.length > 2 ? true : false }}
              onLoad={() => {
                let tempLoaded = [...loadedImages];
                tempLoaded.push("truck");
                setLoadedImages(tempLoaded);
              }}
            />
          </div>
        </div>
        <div className="app-login-form-container">
          {verificationTypes ? (
            <Space
              direction="vertical"
              size="large"
              style={{
                marginTop: "5%",
                width: "70%",
                justifyContent: "space-between",
              }}
            >
              <h2>Hoş geldiniz</h2>
              <h4>Doğrulama yönteminizi seçin</h4>

              <Form
                layout="vertical"
                name="basic"
                onFinish={(val) => onFinish(val)}
                style={{ width: "100%" }}
              >
                <Form.Item
                  name="verificationType"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen doğrulama tipini seçin!",
                    },
                  ]}
                >
                  <Radio.Group
                    style={{ display: "flex", flexDirection: "column", gap: 8 }}
                  >
                    {verificationTypes.includes("LOGIN-SMS") && (
                      <Radio value="LOGIN-SMS">SMS ile Giriş</Radio>
                    )}
                    {verificationTypes.includes("LOGIN-EMAIL") && (
                      <Radio value="LOGIN-EMAIL">E-posta ile Giriş</Radio>
                    )}
                  </Radio.Group>
                </Form.Item>
                <Form.Item>
                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    block
                    loading={loading}
                    style={{ background: "#F47729", borderRadius: "10px" }}
                  >
                    Doğrulama Kodu Gönder
                  </Button>
                </Form.Item>
              </Form>
            </Space>
          ) : verification ? (
            <OtpPage verification={verification} />
          ) : (
            <Space
              direction="vertical"
              size="large"
              style={{
                marginTop: "5%",
                width: "70%",
                justifyContent: "space-between",
              }}
            >
              <h2>Hoş geldiniz</h2>
              <h4>Giriş Yap</h4>
              <Form
                layout="vertical"
                name="basic"
                onFinish={(val) => handleLogin(val)}
                style={{ width: "100%" }}
              >
                <Form.Item
                  label="E-Posta"
                  name="email"
                  rules={[
                    {
                      type: "email",
                      message: "Lütfen e-posta adresinizi kontrol ediniz.",
                    },
                    {
                      required: true,
                      message: "Lütfen e-posta adresinizi giriniz.",
                    },
                  ]}
                >
                  <Input size="large" style={{ borderRadius: "10px" }} />
                </Form.Item>

                <Form.Item
                  label="Parola"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen parolanızı giriniz.",
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    style={{ borderRadius: "10px" }}
                  />
                </Form.Item>

                <Form.Item>
                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    block
                    loading={loading}
                    style={{ background: "#F47729", borderRadius: "10px" }}
                  >
                    Giriş Yap
                  </Button>
                </Form.Item>
                <Form.Item>
                  <Button
                    size="large"
                    type="text"
                    onClick={() => history.push("/auth/forgot-password")}
                    loading={loading}
                  >
                    Şifrenizi mi unuttunuz? Hemen sıfırlayın
                  </Button>
                </Form.Item>
              </Form>
            </Space>
          )}
        </div>
      </div>
    </>
  );
};

export default LoginPage;
